import axios, { AxiosRequestConfig } from 'axios'
import _ from 'lodash'
import fetch from 'node-fetch'

import { config, sanitize } from '@fairhq/common'

import { getDefaultHeaders } from './getDefaultHeaders'

const { baseUrl } = config

const getHeadersWithJSON = (getState: () => unknown) => {
  const headers = {
    ...getDefaultHeaders(getState),
    'Content-Type': 'application/json',
  }

  return headers
}

export const handleError = async (response: any) => {
  if (response.status >= 400 && response.status < 600) {
    const { message } = await response.json()
    let error = { name: response.statusText, message: response.statusText }
    if (_.isArray(message)) {
      const firstMessage = message?.[0]?.messages?.[0]
      error = {
        name: firstMessage?.id || error.name,
        message: firstMessage?.message || error.name,
      } as Error
    }
    throw error
  }
  return response
}

export const http = {
  get(getState: () => unknown, url: string, headers = {}) {
    return fetch(new URL(url, baseUrl).toString(), {
      method: 'GET',
      headers: { ...getHeadersWithJSON(getState), ...headers },
    }).then(handleError)
  },
  getWithAxios(
    getState: () => unknown,
    url: string,
    options: AxiosRequestConfig = {}
  ) {
    return axios.get(new URL(url, baseUrl).toString(), {
      ...options,
      headers: { ...getDefaultHeaders(getState), ...options.headers },
    })
  },
  post(getState: () => unknown, url: string, data: any, headers = {}) {
    return fetch(new URL(url, baseUrl).toString(), {
      method: 'POST',
      headers: { ...getHeadersWithJSON(getState), ...headers } as any,
      body: JSON.stringify(sanitize(data)),
    }).then(handleError)
  },
  postWithAxios(
    getState: () => unknown,
    url: string,
    data: any,
    options: AxiosRequestConfig = {}
  ) {
    return axios.post(new URL(url, baseUrl).toString(), data, {
      ...options,
      headers: { ...getDefaultHeaders(getState), ...options.headers } as any,
    })
  },
  put(getState: () => unknown, url: string, data: any, headers = {}) {
    return fetch(new URL(url, baseUrl).toString(), {
      method: 'PUT',
      headers: { ...getHeadersWithJSON(getState), ...headers },
      body: JSON.stringify(sanitize(data)),
    }).then(handleError)
  },
  putWithAxios(
    getState: () => unknown,
    url: string,
    data: any,
    options: AxiosRequestConfig = {}
  ) {
    return axios.put(new URL(url, baseUrl).toString(), data, {
      ...options,
      headers: { ...getDefaultHeaders(getState), ...options.headers } as any,
    })
  },
  patch(getState: () => unknown, url: string, data: any, headers = {}) {
    return fetch(new URL(url, baseUrl).toString(), {
      method: 'PATCH',
      headers: { ...getHeadersWithJSON(getState), ...headers },
      body: JSON.stringify(sanitize(data)),
    }).then(handleError)
  },
  delete(getState: () => unknown, url: string, headers = {}) {
    return fetch(new URL(url, baseUrl).toString(), {
      method: 'DELETE',
      headers: { ...getHeadersWithJSON(getState), ...headers },
    }).then(handleError)
  },
}
